; (function (inovestor) {
    inovestor.ms.libRef = inovestor.ms.libRef || {};

    if (typeof module === "object" && typeof module.exports === "object") {
        inovestor.ms.libRef.numeral = require("numeral");
        inovestor.ms.libRef.moment = require("moment");
    } else {
        inovestor.ms.libRef.numeral = window.numeral;
        inovestor.ms.libRef.moment = window.moment;
    }
})(inovestor);
/*!
 * Inovestor knockout custom binders extensions
 */
; (function (numeral, moment, ko, inovestor, undefined) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.ko = {};

    // Create observable so others can bind to it
    inovestor.ms.ko.currentLanguage = ko.observable();

    // Set default languages based on current config
    updateLanguages();

    // Register plugins to core to change language when needed
    inovestor.ms.core.instances.register(inovestor.ms.ko, updateLanguages);

    function updateLanguages(){
        if (inovestor.ms.core.currentLanguage === 'fr') {
            numeral.language('fr-CA');
            moment.locale('fr-CA');
            inovestor.ms.ko.currentLanguage(inovestor.ms.core.currentLanguage);
        }
        else {
            numeral.language('en');
            moment.locale('en-CA');
            inovestor.ms.ko.currentLanguage(inovestor.ms.core.currentLanguage);
        }
    }

})(inovestor.ms.libRef.numeral, inovestor.ms.libRef.moment, inovestor.ms.libRef.ko, inovestor);


/**
 * Bootstrap Datepicker Binding Handler
 * 
 * Taken from: http://eonasdan.github.io/bootstrap-datetimepicker/Installing/#knockout
 * 
 * For options see: http://eonasdan.github.io/bootstrap-datetimepicker/Options
 */
ko.bindingHandlers.dateTimePicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        //initialize datepicker with some optional options
        var options = allBindingsAccessor().dateTimePickerOptions || {};
        $(element).datetimepicker(options);

        //when a user changes the date, update the view model
        ko.utils.registerEventHandler(element, "dp.change", function (event) {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
                if (event.date != null && !(event.date instanceof Date)) {
                    value(event.date.toDate());
                } else {
                    value(event.date);
                }
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var picker = $(element).data("DateTimePicker");
            if (picker) {
                picker.destroy();
            }
        });

        // Handle localization
        inovestor.ms.ko.currentLanguage.subscribe(function (newValue) {
            var picker = $(element).data("DateTimePicker");
            if (newValue === 'fr' && picker) {
                picker.options({ locale: 'fr-ca' });
            }
            else if (newValue === 'en' && picker) {
                picker.options({ locale: 'en' });
            }
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

        var picker = $(element).data("DateTimePicker");
        //when the view model is updated, update the widget
        if (picker) {
            var koDate = ko.utils.unwrapObservable(valueAccessor());

            //in case return from server datetime i am get in this form for example /Date(93989393)/ then fomat this
            koDate = (typeof (koDate) !== 'object') ? new Date(parseFloat(koDate.replace(/[^0-9]/g, ''))) : koDate;

            picker.date(koDate);
        }
    }
};
/* 
	changeIndicator
	Options:	-Object with:
                    -groupKey (string)
                    -change (observable)
                    -percentChange (observable)
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.changeIndicator = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var valueBinding = valueAccessor();

            // Get value depending on supported types
            if (typeof valueBinding === "object") {
                // Options defaults
                var groupKey = null;
                var change = null;
                var percentChange = null;

                // Get binding values
                if (valueBinding.groupKey) {
                    if (typeof valueBinding.groupKey === "string")
                        groupKey = valueBinding.groupKey;
                    if (!inovestor.ms.core.isNullOrUndefined(valueBinding.change)) {
                        if (typeof valueBinding.change === "function")
                            change = valueBinding.change();
                        else
                            change = valueBinding.change;
                    }
                    if (!inovestor.ms.core.isNullOrUndefined(valueBinding.percentChange)) {
                        if (typeof valueBinding.percentChange === "function")
                            percentChange = valueBinding.percentChange();
                        else
                            percentChange = valueBinding.percentChange;
                    }
                }

                if (groupKey) {
                    var name = '$changeIndicatorGroup' + groupKey;

                    if (!bindingContext.$root[name]) {
                        bindingContext.$root[name] = {
                            leftWidth: ko.observable(null),
                            rightWidth: ko.observable(null),
                            scopes: []
                        };
                    }

                    var $changeIndicatorGroup = bindingContext.$root[name];

                    // Setup new child scope for element
                    var scope = {
                        element: null,
                        parent: $changeIndicatorGroup,
                        calculated: ko.observable(false),
                        change: ko.observable(change),
                        percentChange: ko.observable(percentChange),
                    };
                    scope.leftWidth = ko.computed(function () {
                        return scope.calculated() ? scope.parent.leftWidth() + 'px' : null;
                    }, scope);
                    scope.rightWidth = ko.computed(function () {
                        return scope.calculated() ? scope.parent.rightWidth() + 'px' : null;
                    }, scope);
                    $(element).data('changeIndicatorScope', scope);

                    // Add new scope to array of scopes
                    var index = $changeIndicatorGroup.scopes.length;
                    $changeIndicatorGroup.scopes.push(scope);

                    scope.element = $('<div class="ino-change-indicator" data-bind="with: $root.' + name + '.scopes[' + index + ']"></a>');

                    $(element).append(scope.element);
                    scope.element.html(inovestor.ms.ko.templates.changeIndicator);
                    setTimeout(function () {
                        ko.bindingHandlers.changeIndicator.tryCalculateWidths($changeIndicatorGroup);
                    });
                }
            }
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var valueBinding = valueAccessor();
            if (typeof valueBinding === "object") {
                // Options defaults
                var scope = $(element).data('changeIndicatorScope');
                var groupKey = null;
                var change = null;
                var percentChange = null;

                if (valueBinding.groupKey) {
                    if (typeof valueBinding.groupKey === "string")
                        groupKey = valueBinding.groupKey;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.change)) {
                    if (typeof valueBinding.change === "function")
                        change = valueBinding.change();
                    else
                        change = valueBinding.change;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.percentChange)) {
                    if (typeof valueBinding.percentChange === "function")
                        percentChange = valueBinding.percentChange();
                    else
                        percentChange = valueBinding.percentChange;
                }

                if (scope) {
                    scope.change(change);
                    scope.percentChange(percentChange);
                }

                if (groupKey) {
                    var name = '$changeIndicatorGroup' + groupKey;
                    var $changeIndicatorGroup = bindingContext.$root[name];
                    ko.bindingHandlers.changeIndicator.tryCalculateWidths($changeIndicatorGroup);
                }
            }

        },
        tryCalculateWidths: function (changeIndicatorGroup) {
            if(changeIndicatorGroup.calculateWidthsRequest != null){
                clearTimeout(changeIndicatorGroup.calculateWidthsRequest);
            }
            changeIndicatorGroup.calculateWidthsRequest = setTimeout(function () {
                // reset max values
                changeIndicatorGroup.leftWidth(null);
                changeIndicatorGroup.rightWidth(null);
                // check each scope
                for(var i = 0; i < changeIndicatorGroup.scopes.length; i++){
                    var scope = changeIndicatorGroup.scopes[i];
                    scope.calculated(false);

                    var leftW = $(scope.element).find('.pull-left').outerWidth();
                    var rightW = $(scope.element).find('.pull-right').outerWidth();

                    if (leftW > changeIndicatorGroup.leftWidth())
                        changeIndicatorGroup.leftWidth(leftW);
                    if (rightW > changeIndicatorGroup.rightWidth())
                        changeIndicatorGroup.rightWidth(rightW);

                    scope.calculated(true);
                    changeIndicatorGroup.calculateWidthsRequest = null;
                }
            }, 10);
        }
    };
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Checkbox knockout binder
	Options:	-Object with:
                    -isChecked (observable)
                    -labelText (observable string)
                    -disabled (observable boolean)
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.checkbox = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = valueAccessor();
            var allBindings = ko.unwrap(allBindingsAccessor());

            // Get value depending on supported types
            if (typeof valueBinding === "object") {

                // Options defaults
                var $checkboxSettings = {
                    isChecked: new ko.observable(false),
                    labelText: ko.observable(),
                    disabled: new ko.observable(false),

                    onCheckedToggle: function () {
                        if (!$checkboxSettings.disabled()) {
                            var oldValue = $checkboxSettings.isChecked();
                            $checkboxSettings.isChecked(!oldValue);
                        }
                    }
                };

                // Get binding values
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.isChecked)) {
                    if (typeof valueBinding.isChecked === "function")
                        $checkboxSettings.isChecked = valueBinding.isChecked;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.labelText)) {
                    if (typeof valueBinding.labelText === "function")
                        $checkboxSettings.labelText(valueBinding.labelText());
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.disabled)) {
                    if (typeof valueBinding.disabled === "function")
                        $checkboxSettings.disabled = valueBinding.disabled;
                }

                var name = '';
                for (var i = 1; i <= 50; i++) {
                    if (!viewModel['$checkboxSettings' + i]) {
                        name = '$checkboxSettings' + i;
                        break;
                    }
                }
                viewModel[name] = $checkboxSettings;
                $(element).data('checkboxSettingsName', name);

                var checkboxEle = $('<div class="ino-checkbox" data-bind="with: ' + name + '"></div>');
                $(element).append(checkboxEle);
                checkboxEle.html(inovestor.ms.ko.templates.checkbox);
                if ($checkboxSettings.disabled())
                    $(element).find('.ino-checkbox-group').addClass('disabled');
            }

        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            // This is to handle the language change and retrieve the new labelText()
            var valueBinding = valueAccessor();
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);
            var name = $(element).data('checkboxSettingsName');
            var $checkboxSettings = viewModel[name];

            if ($checkboxSettings) {
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.labelText)) {
                    if (typeof valueBinding.labelText === "function")
                        $checkboxSettings.labelText(valueBinding.labelText());
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.disabled)) {
                    if (typeof valueBinding.disabled === "function")
                        $checkboxSettings.disabled = valueBinding.disabled;
                }

                if ($checkboxSettings.disabled())
                    $(element).find('.ino-checkbox-group').addClass('disabled');
            }

        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Currency knockout binder
	Options:	-showDecimals (bool)
				-showZero (bool)
                -showAsLargeNumber (bool)
                -defaultValue (string)
                -decimalPlaces(number)
                -decimalPlacesCriteria(boolean) : Flag to use decimalPlacesValue as Max Decimal Places
                -decimalPlacesValue(number) : Max Decimal Places to use when decimalPlacesCriteria is true
                -maxDecimalPlaces(number)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.currency = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());

            // Possible options
            var showDecimals = null;
            var showZero = null;
            var showAsLargeNumber = null;
            var decimalPlaces = null;
            var maxDecimalPlaces = null;
            var defaultValue = null;

            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showDecimals)) {
                if (typeof allBindings.showDecimals === "boolean")
                    showDecimals = allBindings.showDecimals;
            }
            if (allBindings.decimalPlaces && typeof allBindings.decimalPlaces == "number") {
                decimalPlaces = allBindings.decimalPlaces;
            }
            if (allBindings.maxDecimalPlaces && typeof allBindings.maxDecimalPlaces == "number") {
                maxDecimalPlaces = allBindings.maxDecimalPlaces;
            }
            if (allBindings.decimalPlacesCriteria && typeof allBindings.decimalPlacesCriteria == "boolean" && allBindings.decimalPlacesCriteria === true) {
                if (allBindings.decimalPlacesValue && typeof allBindings.decimalPlacesValue == "number") 
                    maxDecimalPlaces = allBindings.decimalPlacesValue;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showZero)) {
                if (typeof allBindings.showZero === "boolean")
                    showZero = allBindings.showZero;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showAsLargeNumber)) {
                if (typeof allBindings.showAsLargeNumber === "boolean")
                    showAsLargeNumber = allBindings.showAsLargeNumber;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue)) {
                if (typeof allBindings.defaultValue === "string")
                    defaultValue = allBindings.defaultValue;
            }

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType === "number")
                    value = predicate;
                else if (predicateType === "string")
                    value = predicate;
            }

            var formattedValue = ko.bindingHandlers.currency.format(value, showZero, showDecimals, showAsLargeNumber, decimalPlaces, maxDecimalPlaces, defaultValue);
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        },
        format: function (value, showZero, showDecimals, showAsLargeNumber, minDecimalPlaces, maxDecimalPlaces, defaultValue) {
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);
            
            // Options defaults
            showDecimals = inovestor.ms.core.isNullOrUndefined(showDecimals) ? true : showDecimals;
            showZero = showZero || false;
            showAsLargeNumber = showAsLargeNumber || false;
            minDecimalPlaces = minDecimalPlaces || 2;
            maxDecimalPlaces = maxDecimalPlaces || null;
            defaultValue = defaultValue || resources.currencyFormats.empty;

            var fullNumber = null;
            if (inovestor.ms.core.isNullOrUndefined(defaultValue))
                defaultValue = resources.currencyFormats.empty;

            if (typeof value === "string")
                value = inovestor.ms.core.getNumber(value);
            if (typeof value === "number")
                fullNumber = value.toString();

            var formattedValue = defaultValue;
            if (!inovestor.ms.core.isEmptyString(fullNumber)) {
                if (fullNumber === "0" && showZero === false)
                    formattedValue = defaultValue;
                else if (!showAsLargeNumber) {
                    if (!showDecimals)
                        formattedValue = numeral(fullNumber).format(resources.currencyFormats.noDecimals);
                    else {
                        var decimalsToShow = minDecimalPlaces;
                       if (maxDecimalPlaces)
                            decimalsToShow = ko.bindingHandlers.number.calculateDecimalPlaces(value, minDecimalPlaces, maxDecimalPlaces);
                        var format = inovestor.ms.core.stringFormat(resources.currencyFormats.withDecimals, { decimals: Array(decimalsToShow + 1).join("0") });
                        formattedValue = numeral(fullNumber).format(format);
                    }
                }
                else {
                    if (!showDecimals)
                        formattedValue = numeral(fullNumber).format(resources.currencyFormats.largeNumberNoDecimals);
                    else {
                        var decimalsToShow = minDecimalPlaces;
                        if (maxDecimalPlaces)
                            decimalsToShow = ko.bindingHandlers.number.calculateDecimalPlaces(value, minDecimalPlaces, maxDecimalPlaces);

                        var format = inovestor.ms.core.stringFormat(resources.currencyFormats.largeNumberWithDecimals, { decimals: Array(decimalsToShow + 1).join("0") });
                        formattedValue = numeral(fullNumber).format(format);
                    }
                }
            }

            return formattedValue;
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	Date knockout binder
	Options:	-format (string : moment format)
                -defaultValue (string)
*/
; (function (ko, moment, inovestor, undefined) {
    ko.bindingHandlers.date = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());

            // Possible options
            var format = null;
            var defaultValue = null;

            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.format)) {
                if (typeof allBindings.format === "string")
                    format = allBindings.format;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue)) {
                if (typeof allBindings.defaultValue === "string")
                    defaultValue = allBindings.defaultValue;
            }

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType === "string") // Given a string; treat it as a date in string format
                    value = predicate;
                else if (moment.isDate(predicate)) // Given a string; treat it as a property name on the data value
                    value = predicate;
            }

            var formattedValue = ko.bindingHandlers.date.format(value, format, defaultValue);
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        },

        format: function (value, format, defaultValue) {
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);
            
            // options defaults
            format = format || 'LL';
            defaultValue = defaultValue || resources.dateFormats.empty;

            var formattedValue = defaultValue;
            if (!inovestor.ms.core.isNullOrUndefined(value)) {
                formattedValue = moment(value).format(format);
            }
            return formattedValue;
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.moment, inovestor);

/* 
	Datepicker knockout binder
*/
; (function (ko, moment, inovestor, undefined) {
    ko.bindingHandlers.datepicker = {
        init: function (element, valueAccessor) {
            var valueBinding = valueAccessor();
            var $element = $(element);
            var counter = 1;
            var interval = setInterval(function () {
                counter++;
                if ($.datepicker) {
                    clearInterval(interval);
                    if (!$element.data('datepicker')) {
                        var startingDate = valueBinding();
                        var currentDate = new Date();
                        $element.datepicker({
                            yearRange: (currentDate.getFullYear() - 15) + ':' + currentDate.getFullYear(),
                            minDate: '-15y',
                            maxDate: 0,
                            changeMonth: true,
                            changeYear: true,
                        });

                        //handle the field changing
                        ko.utils.registerEventHandler(element, "change", function () {
                            valueBinding($element.datepicker("getDate"));
                            $element.blur();
                        });

                        //handle disposal (if KO removes by the template binding)
                        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                            $(element).datepicker("destroy");
                        });

                        //Set default value
                        if (!inovestor.ms.core.isNullOrUndefined(startingDate)) {
                            var date = null;
                            if (startingDate instanceof moment)
                                date = moment(startingDate).toDate();
                            else if (startingDate instanceof Date)
                                date = startingDate;

                            if (date != null)
                                $element.datepicker("setDate", date);
                        }

                        // Handle localization
                        inovestor.ms.ko.currentLanguage.subscribe(function (newValue) {
                            if (newValue === 'fr') {
                                $(element).datepicker("option", $.datepicker.regional['fr-CA']);
                            }
                            else if (newValue === 'en') {
                                $(element).datepicker("option", $.datepicker.regional['en']);
                            }
                        });

                        $element.addClass('ino-datepicker');
                        $element.attr('readonly', 'readonly');
                    }
                }
                if (counter > 3) {
                    clearInterval(interval);
                }
            }, 300);
        },
        //update the control when the view model changes
        update: function (element, valueAccessor) {
            var $element = $(element);
            var value = ko.utils.unwrapObservable(valueAccessor());

            if (!inovestor.ms.core.isNullOrUndefined($element.datepicker)) {
                var date = null;

                if (!inovestor.ms.core.isNullOrUndefined(value)) {
                    if (value instanceof moment)
                        date = moment(value).toDate();
                    else if (value instanceof Date)
                        date = value;

                    if (date != null)
                        $element.datepicker("setDate", date);
                }
            }
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.moment, inovestor);
/* 
	Dropdown
	Options:	-Object with:
                    -inputFilter (observable)
                    -isFilterable (observable boolean)
                    -items (observable array)
                    -itemName (function)
                    -selectedName (observable)
                    -selectedValue (observable)
                    -subMenuGroupKey (string)
                    -subMenuItemName (function)
                    -disabled (observable boolean)
                    -onChange (function callback)
                    -onBeforeChange (function callback)
                            Can return either a truthy or falsy object or a promise-like object
                            that will return a truthy or falsy object. If reponse is truthy,
                            selection occurs. If response is falsy, selection does not occur.
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.dropdown = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var updateValue = function (settings, item) {
                var oldValue = settings.selectedValue();

                settings.selectedValue(item);
                
                if (oldValue !== item && settings.onChange && typeof settings.onChange === 'function')
                    settings.onChange(item);

                if (settings.inputFilter && typeof settings.inputFilter === 'function')
                    settings.inputFilter('');
            }

            var checkForCallbacksAndUpdateValue = function (settings, item) {
                // Check if there's an onBeforeChange callback registered
                if (settings.onBeforeChange && typeof settings.onBeforeChange === 'function') {
                    
                    // A callback is registered so call it and pass the new item
                    var callbackReturn = settings.onBeforeChange(item);

                    // Now check if a promise is returned or just a value indicating whether to update the selected value or not.
                    // To check for a promise, we only check if the object is "thenable" and, if it is, await it
                    if (callbackReturn && typeof callbackReturn.then === 'function') {
                        // It's a promise-like object. Await it.
                        callbackReturn.then(function (accept) {
                            // If the resolve from the promise is truthy, update the value
                            if (accept) {
                                updateValue(settings, item);
                            }
                        });
                    } else {
                        // It's not a promise so if the result is "truthy", select the item
                        if (callbackReturn) {
                            updateValue(settings, item);
                        }
                    }
                } else {
                    // No onBeforeChange callback registered, just update the value as usual
                    updateValue(settings, item);
                }
            };

            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // Get value depending on supported types
            if (typeof valueBinding === "object") {

                // Options defaults
                var $dropdownSettings = {
                    inputFilter: new ko.observable(),
                    isFilterable: new ko.observable(false),
                    disabled: new ko.observable(false),

                    items: null,
                    itemName: function (item) {
                        return item;
                    },
                    selectedName: function () {
                        var selectedVal = $dropdownSettings.selectedValue();
                        if ($dropdownSettings.subMenuGroupKey)
                            return selectedVal ? $dropdownSettings.subMenuItemName(selectedVal) : '';
                        else
                            return selectedVal ? $dropdownSettings.itemName(selectedVal) : '';
                    },
                    selectedValue: new ko.observable(),

                    subMenuGroupKey: null,
                    subMenuItemName: null,

                    onBeforeChange: null,
                    onChange: null,

                    onItemSelected: function (item, event) {
                        // If has subMenuGroupKey, it means there is a Submenu
                        if ($dropdownSettings.subMenuGroupKey) {
                            var ddmContainer = $(event.target).closest('.dropdown-menu-container');
                            var ddsm = $(event.target).closest('.dropdown-submenu');
                            var ddm = $(event.target).closest('.dropdown-menu');
                            // Remove active states on other Submenus
                            ddm.find('.dropdown-submenu.active').not(ddsm).removeClass('active');
                            ddsm.toggleClass('active');

                            // Set top level
                            if (ddsm.hasClass('active'))
                                ddmContainer.addClass('item-selected');
                            else
                                ddmContainer.removeClass('item-selected');

                            event.stopPropagation();
                            event.preventDefault();
                        }
                        // If there is no Submenu, set the item as the selected value
                        else {
                            checkForCallbacksAndUpdateValue($dropdownSettings, item);
                        }

                    },
                    onSubMenuItemSelected: function (item, event) {
                        checkForCallbacksAndUpdateValue($dropdownSettings, item);
                    },

                    toggleDropdowMenu: function (item, event) {
                        $(element).find('.dropdown > .dropdown-toggle').trigger('click');
                    }
                };

                // Get binding values
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.items)) {
                    $dropdownSettings.items = valueBinding.items;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.inputFilter)) {
                    if (typeof valueBinding.inputFilter === "function")
                        $dropdownSettings.inputFilter = valueBinding.inputFilter;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.disabled)) {
                    if (typeof valueBinding.disabled === "function")
                        $dropdownSettings.disabled = valueBinding.disabled;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.isFilterable)) {
                    if (typeof valueBinding.isFilterable === "function")
                        $dropdownSettings.isFilterable = valueBinding.isFilterable;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.itemName)) {
                    if (typeof valueBinding.itemName === "function")
                        $dropdownSettings.itemName = valueBinding.itemName;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.subMenuGroupKey)) {
                    if (typeof valueBinding.subMenuGroupKey === "string")
                        $dropdownSettings.subMenuGroupKey = valueBinding.subMenuGroupKey;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.selectedName)) {
                    if (typeof valueBinding.selectedName === "function")
                        $dropdownSettings.selectedName = valueBinding.selectedName;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.selectedValue)) {
                    if (typeof valueBinding.selectedValue === "function")
                        $dropdownSettings.selectedValue = valueBinding.selectedValue;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.subMenuItemName)) {
                    if (typeof valueBinding.subMenuItemName === "function")
                        $dropdownSettings.subMenuItemName = valueBinding.subMenuItemName;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.onChange)) {
                    if (typeof valueBinding.onChange === "function")
                        $dropdownSettings.onChange = valueBinding.onChange;
                }
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.onBeforeChange)) {
                    if (typeof valueBinding.onBeforeChange === "function")
                        $dropdownSettings.onBeforeChange = valueBinding.onBeforeChange;
                }

                var name = '';
                for (var i = 1; i <= 50; i++) {
                    if (!viewModel['$dropdownSettings' + i]) {
                        name = '$dropdownSettings' + i;
                        break;
                    }
                }
                viewModel[name] = $dropdownSettings;

                var dropdownEle = $('<div class="ino-dropdown" data-bind="with: ' + name + '"></div>');
                $(element).append(dropdownEle);
                dropdownEle.html(inovestor.ms.ko.templates.drowdown);
                $(dropdownEle).find('[data-toggle="dropdown"]').dropdown();

                $(element).find('.dropdown').on('show.bs.dropdown', function () {
                    $(document.createElement('div'))
                        .addClass('ino-dropdown-backdrop')
                        .insertAfter($(this));
                });
                $(element).find('.dropdown').on('shown.bs.dropdown', function () {
                    var modal = $(element).closest('.ino-ms-modal');
                    if (modal.length > 0)
                        modal.addClass('child-modal-opened');

                    var hasFiltering = dropdownEle.find('.filterable-input').length > 0;
                    if (hasFiltering) {
                        dropdownEle.addClass('filtering');
                        var tryMobileInput = $(element).find('.mobile-input-container').css('display') === 'inline-block';
                        if (tryMobileInput) {
                            $(element).find('.mobile-input-container .filterable-input').trigger('focus');
                        }
                        $(element).find('.filterable-input').first().trigger('focus');
                    }
                });

                $(element).find('.dropdown').on('hide.bs.dropdown', function () {
                    dropdownEle.removeClass('filtering');
                    $(element).find('.ino-dropdown-backdrop').remove();

                    if ($dropdownSettings.isFilterable())
                        $dropdownSettings.inputFilter('');
                });

                $(element).find('.dropdown').on('hidden.bs.dropdown', function () {
                    var modal = $(element).closest('.ino-ms-modal');
                    if (modal.length > 0)
                        modal.removeClass('child-modal-opened');
                });

                if (!$dropdownSettings.subMenuGroupKey)
                    $(element).find('.dropdown-menu-container').addClass('scrollable');

                if ($dropdownSettings.disabled())
                    $(element).find('.dropdown > .dropdown-toggle').attr("disabled", true);
                else
                    $(element).find('.dropdown > .dropdown-toggle').attr("disabled", false);
            }
        },
        //update the control when the view model changes
        update: function (element, valueAccessor) {
            var $element = $(element);
            var valueBinding = ko.unwrap(valueAccessor());
            var disabled = new ko.observable(false);

            if (!inovestor.ms.core.isNullOrUndefined(valueBinding.disabled)) {
                if (typeof valueBinding.disabled === "function")
                    disabled = valueBinding.disabled;
            }

            if (disabled())
                $(element).find('.dropdown > .dropdown-toggle').attr("disabled", true);
            else
                $(element).find('.dropdown > .dropdown-toggle').attr("disabled", false);
        }

    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	Shows an error message based on template in core plugin.
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.errorMessage = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = allBindingsAccessor();
            // Add getter to currentLanguage in order to make sure the bindingHandlers 
            // listens when the observable changes values
            var currentLanguage = inovestor.ms.ko.currentLanguage();
            var errorTemplate = inovestor.ms.core.getErrorTemplate(currentLanguage);

            ko.bindingHandlers.html.update(
				element,
				function () { return errorTemplate; }
				);
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
	groupBy knockout binder
	Options:	-groupBy (string / function : Array property name / callback function used as Group key)
                -dataArray (array / observable : Dataset to group)
                -preSortBy (string / function : item to be used as sorting) Optional
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.groupBy = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            return ko.bindingHandlers.foreach.init(element, valueAccessor, allBindingsAccessor, viewModel, context);
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var value = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var preSortBy = null;
            // options defaults
            var dataArray = [];

            if (allBindings.dataArray) {
                if (typeof allBindings.dataArray === "object" && typeof allBindings.dataArray.length === 'number')
                    dataArray = allBindings.dataArray;
                else if (typeof allBindings.dataArray === "function")
                    dataArray = allBindings.dataArray();

                if (!inovestor.ms.core.isNullOrUndefined(allBindings.preSortBy)) {
                    dataArray = inovestor.ms.core.sortArray(dataArray, false, function (i, b) {
                        if (typeof allBindings.preSortBy === "function")
                            return allBindings.preSortBy(i) < allBindings.preSortBy(b);
                        else if (typeof allBindings.preSortBy === "string")
                            return i[allBindings.preSortBy] < b[allBindings.preSortBy];

                        return false;
                    });
                }

            }

            var allPossibleValues = [];

            if (!inovestor.ms.core.isNullOrUndefined(value)) {
                allPossibleValues = ko.utils.arrayMap(dataArray, function (dataItem) {
                    if (typeof value === 'string' && !inovestor.ms.core.isNullOrUndefined(dataItem[value]))
                        return dataItem[value].trim();
                    else if (typeof value === "function")
                        return value.call(dataItem).trim();

                    return '';
                });
            }
            else
                allPossibleValues = dataArray;

            var groups = ko.utils.arrayMap(ko.utils.arrayGetDistinctValues(allPossibleValues), function (key) {
                return {
                    key: key,
                    groupItems: ko.observableArray()
                };
            });

            $(dataArray).each(function (index, dataItem) {
                var groupFilter = ko.utils.arrayFilter(groups, function (group) {
                    var dataItemKeyValue = '';
                    if (typeof value === 'string' && !inovestor.ms.core.isNullOrUndefined(dataItem[value]))
                        dataItemKeyValue = dataItem[value].trim();
                    else if (typeof value === "function")
                        dataItemKeyValue = value.call(dataItem).trim();

                    return group.key === dataItemKeyValue;
                });
                if (groupFilter.length === 1)
                    groupFilter[0].groupItems.push(dataItem);
            });

            var newValue = function () {
                return {
                    data: groups
                };
            };

            ko.bindingHandlers.foreach.update(element, newValue, allBindingsAccessor, viewModel, context);
        }
    };
})(inovestor.ms.libRef.ko, inovestor);

/* 
	hasError knockout binder
    Options:	-errorMessages (object)
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.hasError = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = allBindingsAccessor();

            // options defaults
            var errorMessages = {};
            var outputErrors = true;

            // defaults
            var isValid = true;
            var errorsForField = null;

            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.errorMessages)) {
                if (typeof allBindings.errorMessages === "function")
                    errorMessages = allBindings.errorMessages();
                else if (typeof allBindings.errorMessages === "object")
                    errorMessages = allBindings.errorMessages;
            }

            // value getter
            var value = null;
            var predicate = valueAccessor();
            var predicateType = typeof predicate;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else if (predicateType === "string") // Given a string; treat it as a property name on the data value
                value = predicate;

            if (typeof value === "string") {
                if (value === '*') {
                    errorsForField = [];
                    for (var invalidProperty in errorMessages) {
                        for (var error in errorMessages[invalidProperty]) {
                            errorsForField.push(errorMessages[invalidProperty][error]);
                        }
                    }

                    if (errorsForField.length > 0)
                        isValid = false;
                }
                else {
                    for (var invalidProperty in errorMessages) {
                        if (invalidProperty === value) {
                            errorsForField = errorMessages[invalidProperty];
                            isValid = false;
                            break;
                        }
                    }
                }
            }

            // Clear errors
            $(element).find('.error-msg').remove();

            if (isValid) {
                $(element).removeClass('has-error');
            }
            else {
                $(element).addClass('has-error');
                if (outputErrors && errorsForField) {
                    for (var error in errorsForField)
                        $(element).find('.error-msg-container').append('<span class="error-msg text-danger small">' + errorsForField[error] + '</span>');
                }
            }
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
	holdButton knockout binder
	Options:	-Object with:
                    -onHeld (observable)
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.holdButton = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = valueAccessor();
            var allBindings = ko.unwrap(allBindingsAccessor());

            var timeoutId = null;

            // Get value depending on supported types
            if (typeof valueBinding === "object") {

                // Options defaults
                var $buttonSettings = {
                    onHeld: null,

                    onClick: function () {

                        $(element).find('.ino-confirm-button').addClass('holding');
                        timeoutId = setTimeout(function () {
                            $buttonSettings.onHeld();
                        }, 1000);
                    },
                    onUnClick: function () {
                        $(element).find('.ino-confirm-button').removeClass('holding');
                        clearTimeout(timeoutId);
                    }
                };

                // Get binding values
                if (!inovestor.ms.core.isNullOrUndefined(valueBinding.onHeld)) {
                    if (typeof valueBinding.onHeld === "function")
                        $buttonSettings.onHeld = valueBinding.onHeld;
                }
                var name = '';
                for (var i = 1; i <= 50; i++) {
                    if (!viewModel['$buttonSettings' + i]) {
                        name = '$buttonSettings' + i;
                        break;
                    }
                }
                viewModel[name] = $buttonSettings;

                var buttonEle = $('<div class="ino-confirm-button" data-bind="with: ' + name + '"></a>');
                $(element).append(buttonEle);
                buttonEle.html(inovestor.ms.ko.templates.holdButton);
            }

        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
    indeterminate
    This binding handler updates the indeterminate state of a checkbox input element.
    It determines whether a checkbox should be displayed in an indeterminate state based on the associated observable value.
    The indeterminate state is used to indicate a partial selection within a group of options.

     Usage:
    <input type="checkbox" data-bind="indeterminate: yourObservable" />

    options : 
         - element: The target DOM element (checkbox).
         - valueAccessor: A function that returns the observable containing the value (true or false) 
          that determines whether the checkbox is in an indeterminate state.
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.indeterminate = {
        update: function (element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            element.indeterminate = value;
        }
    }
})(inovestor.ms.libRef.ko, inovestor);
/* 
	Shows an error message based on template in core plugin.
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.invalidIdentifier = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = allBindingsAccessor();
            // Add getter to currentLanguage in order to make sure the bindingHandlers 
            // listens when the observable changes values
            var currentLanguage = inovestor.ms.ko.currentLanguage();
            var invalidIdentifierTemplate = inovestor.ms.core.getInvalidIdentifierTemplate(currentLanguage);

            ko.bindingHandlers.html.update(
				element,
				function () { return invalidIdentifierTemplate; }
				);
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Shows the loading indicator based on template in core plugin.
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.loadingIndicator = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = allBindingsAccessor();
            // Add getter to currentLanguage in order to make sure the bindingHandlers 
            // listens when the observable changes values
            var currentLanguage = inovestor.ms.ko.currentLanguage();
            var loadingIndicatorTemplate = inovestor.ms.core.getLoadingIndicatorTemplate(currentLanguage);

            ko.bindingHandlers.html.update(
				element,
				function () { return loadingIndicatorTemplate; }
				);
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
    localizedText knockout binder
    Options:	-localizedText (context : Main Object context)
                -enText (string : Property name to use)
                -frText (string : Property name to use)
                -isHtml (bool : use the html binding when true)
                -shouldSetTitle (bool : set title when true)
                -defaultValue (string)
*/
; (function (ko, inovestor, undefined) {

    ko.bindingHandlers.localizedText = {
        getItemValue: function (obj, accessor) {
            if (!inovestor.ms.core.isNullOrUndefined(obj) && !inovestor.ms.core.isNullOrUndefined(accessor)) {
                if (typeof accessor === 'function')
                    return accessor();
                else if (typeof accessor === 'string' && !inovestor.ms.core.isNullOrUndefined(obj[accessor]))
                    return obj[accessor];
            }

            return null;
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);
            // This not only gets the language code, but is also used in order to make sure the binding handler is updated on language change.
            var currentLanguage = inovestor.ms.ko.currentLanguage();

            // Options defaults
            var englishText = '';
            var frenchText = '';
            var isHtml = false;
            var shouldSetTitle = false;
            var defaultValue = resources.localizedTextFormats.empty;

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function")
                value = predicate();
            else if (predicateType === "object")
                value = predicate;

            // Get binding values
            var englishText = ko.bindingHandlers.localizedText.getItemValue(value, allBindings.enText);
            var frenchText = ko.bindingHandlers.localizedText.getItemValue(value, allBindings.frText);
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.isHtml)) {
                if (typeof allBindings.isHtml === 'boolean')
                    isHtml = allBindings.isHtml;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.shouldSetTitle)) {
                if (typeof allBindings.shouldSetTitle === 'boolean')
                    shouldSetTitle = allBindings.shouldSetTitle;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue)) {
                if (typeof allBindings.defaultValue == "string")
                    defaultValue = defaultValue;
            }

            var formattedValue = defaultValue;
            if (currentLanguage === 'en' && !inovestor.ms.core.isEmptyString(englishText))
                formattedValue = englishText;
            else if (currentLanguage === 'fr' && !inovestor.ms.core.isEmptyString(frenchText))
                formattedValue = frenchText;

            if (isHtml) {
                ko.bindingHandlers.html.update(
                  element,
                  function () {
                      return formattedValue;
                  }
                );
            }
            else {
                ko.bindingHandlers.text.update(
                  element,
                  function () {
                      return formattedValue;
                  }
                );
                if (shouldSetTitle)
                    element.title = formattedValue;
            }
        }
    };
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Number knockout binder
	Options:	-showAsLargeNumber (bool)
                -decimalPlaces (number)
                -maxDecimalPlaces (number)
                -numberDivider (number,function)
                -showZero (bool)
                -defaultValue (string)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.number = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // Possible options
            var showZero = null;
            var decimalPlaces = null;
            var maxDecimalPlaces = null;
            var numberDivider = null;
            var showAsLargeNumber = null;
            var maxNumberBeforeLarge = null;
            var defaultValue = null;
            
            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.decimalPlaces) && typeof allBindings.decimalPlaces == "number")
                decimalPlaces = allBindings.decimalPlaces;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.maxDecimalPlaces) && typeof allBindings.maxDecimalPlaces == "number")
                maxDecimalPlaces = allBindings.maxDecimalPlaces;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showAsLargeNumber) && typeof allBindings.showAsLargeNumber == "boolean")
                showAsLargeNumber = allBindings.showAsLargeNumber;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showZero) && typeof allBindings.showZero == "boolean")
                showZero = allBindings.showZero;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.numberDivider)) {
                if (typeof allBindings.numberDivider == "number")
                    numberDivider = allBindings.numberDivider;
                else if (typeof allBindings.numberDivider == "function")
                    numberDivider = allBindings.numberDivider();
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue) && typeof allBindings.defaultValue == "string")
                defaultValue = allBindings.defaultValue;

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType === "number")
                    value = predicate;
                else if (predicateType === "string")
                    value = predicate;
            }

            var formattedValue = ko.bindingHandlers.number.format(value, showZero, decimalPlaces, maxDecimalPlaces, numberDivider, showAsLargeNumber, defaultValue, maxNumberBeforeLarge)
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        },
        calculateDecimalPlaces: function (number, minDecimals, maxDecimals) {
            if (inovestor.ms.core.isNullOrUndefined(number))
                return minDecimals;

            if (Math.floor(number.valueOf()) === number.valueOf()) return minDecimals;
            var decimals = number.toString().split(".")[1].length || 0;

            if (!inovestor.ms.core.isNullOrUndefined(minDecimals) && decimals < minDecimals)
                return minDecimals;
            if (!inovestor.ms.core.isNullOrUndefined(minDecimals) && decimals > maxDecimals)
                return maxDecimals;

            return decimals;
        },
        format: function (value, showZero, minDecimalPlaces, maxDecimalPlaces, numberDivider, showAsLargeNumber, defaultValue, maxNumberBeforeLarge) {
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // options defaults
            showZero = showZero || false;
            minDecimalPlaces = minDecimalPlaces || 0;
            maxDecimalPlaces = maxDecimalPlaces || null;
            numberDivider = numberDivider || 1;
            showAsLargeNumber = showAsLargeNumber || false;
            maxNumberBeforeLarge = maxNumberBeforeLarge || 99999999999999999999;
            defaultValue = defaultValue || resources.numericFormats.empty;

            var fullNumber = "";
            if (typeof value === "string")
                value = inovestor.ms.core.getNumber(value);
            if (typeof value === "number") {
                value = value / numberDivider;
                fullNumber = value.toString();
            }

            // force showAsLargeNumber if number too large to dislay
            if (!showAsLargeNumber && value > maxNumberBeforeLarge)
                showAsLargeNumber = true;

            var formattedValue = defaultValue;
            if (!(fullNumber == "" || (showZero === false && fullNumber == "0"))) {
                if (!showAsLargeNumber) {
                    if (minDecimalPlaces === 0)
                        formattedValue = numeral(fullNumber).format(resources.numericFormats.noDecimals);
                    else {
                        var decimalsToShow = !maxDecimalPlaces ? minDecimalPlaces : ko.bindingHandlers.number.calculateDecimalPlaces(value, minDecimalPlaces, maxDecimalPlaces);
                        var format = inovestor.ms.core.stringFormat(resources.numericFormats.withDecimals, { decimals: Array(decimalsToShow + 1).join("0") })
                        formattedValue = numeral(fullNumber).format(format);
                    }
                }
                else {
                    if (minDecimalPlaces === 0)
                        formattedValue = numeral(fullNumber).format(resources.numericFormats.largeNumberNoDecimals);
                    else {
                        var decimalsToShow = !maxDecimalPlaces ? minDecimalPlaces : ko.bindingHandlers.number.calculateDecimalPlaces(value, minDecimalPlaces, maxDecimalPlaces);
                        var format = inovestor.ms.core.stringFormat(resources.numericFormats.largeNumberWithDecimals, { decimals: Array(decimalsToShow + 1).join("0") })
                        formattedValue = numeral(fullNumber).format(format);
                    }
                }
            }

            return formattedValue;
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
    Knockout binding handler that works as a foreach binding handler with simple order by preset.
    
    On ELEMENT:
        orderedForeach: { 
            data: [observableArray], 
            as: [string (name of the item)], 
            orderBy: [string (property name accessor) || function (callback returning value to order)],
            orderableRows : [string (jquery selector of rows that can be manually ordered)],
            onManualOrder : [function (callback executed when ordering has changed. Passes new list as argument)],
            disableManualOrdering : [observable boolean]
        }
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.orderedForeach = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var value = ko.unwrap(valueAccessor());
            if ($.ui && $.ui.sortable && value.orderableRows && typeof value.orderableRows === 'string') {
                if (value.disableManualOrdering && ko.isObservable(value.disableManualOrdering)) {
                    var sub = value.disableManualOrdering.subscribe(function (newVal) {
                        if (newVal)
                            $(element).sortable('disable');
                        else
                            $(element).sortable('enable');
                    });
                    // Add a knockout domNodeDisposal callback to dispose the subscription to disableManualOrdering
                    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                        sub.dispose();
                    });
                }
            }
            return ko.bindingHandlers.foreach.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var value = ko.unwrap(valueAccessor());

            // options defaults
            var foreachAs = 'item';
            if (value.as && typeof value.as === "string") {
                foreachAs = value.as;
            }

            var lastestListOrder = null;
            if (typeof value.data == 'function') {
                ko.bindingHandlers.sortable.sort(value.orderBy, value.data, true);
                lastestListOrder = value.data();
            }
            else
                return;

            var newValue = function () {
                return {
                    data: value.data,
                    as: foreachAs
                }
            };

            // Add JQuery UI sortable if orderableRows is provided
            if ($.ui && $.ui.sortable && value.orderableRows && typeof value.orderableRows === 'string') {
                var $element = $(element);
                $element.sortable({
                    items: value.orderableRows,
                    disabled: (value.disableManualOrdering && ko.isObservable(value.disableManualOrdering)) ? value.disableManualOrdering() : false,
                    helper: function (d, a) {
                        var td = $(a).find('td');
                        td.each(function (i, ele) {
                            $(ele).attr('td-sort-fix', '');
                            if ($(ele).attr('style'))
                                $(ele).attr('original-style', $(ele).attr('style'));
                            $(ele).css('width', $(ele).outerWidth() + 'px');
                        });
                        return a[0];
                    },
                    stop: function (event, ui) {
                        var newlyOrderedData = [];
                        $element.find(value.orderableRows).each(function () {
                            var context = ko.contextFor(this);
                            newlyOrderedData.push(context[value.as]);

                            var td = $(this).find('td[td-sort-fix]');
                            td.each(function (i, ele) {
                                $(ele).removeAttr('td-sort-fix');
                                $(ele).css('width', '');
                                if ($(ele).attr('original-style'))
                                    $(ele).attr('style', $(ele).attr('original-style'));
                            });
                        });
                        if (value.onManualOrder && typeof value.onManualOrder === 'function' && JSON.stringify(newlyOrderedData) != JSON.stringify(lastestListOrder)) {
                            value.onManualOrder(newlyOrderedData);
                            lastestListOrder = newlyOrderedData;
                        }
                    }
                });
            }

            ko.bindingHandlers.foreach.update(element, newValue, allBindingsAccessor, viewModel, bindingContext);
        }
    };

})(inovestor.ms.libRef.ko, inovestor);

/* 
	Ordinal Number knockout binder
    Options:	-defaultValue (string)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.ordinalNumber = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());

            // Possible options
            var defaultValue = null;
            
            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue) && typeof allBindings.defaultValue == "string")
                defaultValue = allBindings.defaultValue;

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType === "number")
                    value = predicate;
                else if (predicateType === "string")
                    value = predicate;
            }

            var formattedValue = ko.bindingHandlers.ordinalNumber.format(value, defaultValue)
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        },
        format: function (value, defaultValue) {
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            if (!inovestor.ms.core.isNullOrUndefined(value) && value !== '' && !isNaN(value)) {
                return numeral(value).format('0o');
            }

            return defaultValue || resources.ordinalFormats.empty;
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	Percentage knockout binder
	Options:	-decimalPlaces (number)
				-showZero (bool)
                -valueAsPercent (bool)
                -defaultValue(string)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.percentage = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());

            // options defaults
            var decimalPlaces = null;
            var showZero = null;
            var valueAsPercent = null;
            var defaultValue = null;
            
            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.valueAsPercent) && typeof allBindings.valueAsPercent == "boolean")
                valueAsPercent = allBindings.valueAsPercent;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.decimalPlaces) && typeof allBindings.decimalPlaces == "number")
                decimalPlaces = allBindings.decimalPlaces;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.showZero) && typeof allBindings.showZero == "boolean")
                showZero = allBindings.showZero;
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue) && typeof allBindings.defaultValue == "string")
                defaultValue = allBindings.defaultValue;

            // value getter
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType == "function")
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType == "string")
                    value = predicate;
                else if (predicateType == "number")
                    value = predicate;
            }

            var formattedValue = ko.bindingHandlers.percentage.format(value, decimalPlaces, showZero, valueAsPercent, defaultValue)
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        },

        format: function (value, decimalPlaces, showZero, valueAsPercent, defaultValue) {
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // options defaults
            decimalPlaces = decimalPlaces || 0;
            showZero = showZero || false;
            valueAsPercent = valueAsPercent || false;
            defaultValue = defaultValue || resources.percentFormats.empty;

            var fullNumber = "";
            if (typeof value === "string")
                value = inovestor.ms.core.getNumber(value);
            if (typeof value === "number") {
                if (valueAsPercent)
                    value = value / 100;
                fullNumber = value.toString();
            }

            var formattedValue = defaultValue;
            if (!(fullNumber == "" || (showZero === false && fullNumber == "0"))) {
                if (decimalPlaces === 0)
                    formattedValue = numeral(fullNumber).format(resources.percentFormats.noDecimals);
                else {
                    var format = inovestor.ms.core.stringFormat(resources.percentFormats.withDecimals, { decimals: Array(decimalPlaces + 1).join("0") })
                    formattedValue = numeral(fullNumber).format(format);
                }
            }

            return formattedValue;
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	phoneNumber knockout binder
	Options:	-defaultValue (string / number / observable / function) : If a number, will try to output as a telephone format
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.phoneNumber = {
        update: function (element, valueAccessor) {
            var valueBinding = ko.unwrap(valueAccessor());

            // value getter
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType == "function")
                value = predicate();
            else {
                // Because this is a raw data (not an observable), but we still want to bind the format displayed depending on the language, 
                // we call the currentLanguage observable in order to make sure the binding handler is updated on language change.
                inovestor.ms.ko.currentLanguage();

                if (predicateType == "string")
                    value = predicate;
                else if (predicateType == "number")
                    value = predicate;
            }

            var fullNumber = null;

            if (typeof value === "string")
                value = inovestor.ms.core.getNumber(value);
            if (typeof value === "number")
                fullNumber = value.toString();

            var formattedValue = '-';
            if (!inovestor.ms.core.isEmptyString(fullNumber)) {
                if (fullNumber.length == 10)
                    formattedValue = fullNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                else if (fullNumber.length == 11)
                    formattedValue = fullNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4");
            }
            ko.bindingHandlers.text.update(
                element,
                function () { return formattedValue; }
            );
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Popover knockout binder
	Options:	-popoverOptions (object)
*/
; (function (ko, numeral, inovestor, undefined) {

    ko.bindingHandlers.popover = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var currentLanguage = inovestor.ms.ko.currentLanguage();

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function") // Given a function; run it against the data value
                value = predicate();
            else if (predicateType === "object") {
                if (predicate.text) {
                    if (typeof predicate.text === "function")
                        value = predicate.text();
                    else if (typeof predicate.text === "string")
                        value = predicate.text;
                }
                else if (currentLanguage === 'fr' && predicate.frText) {
                    if (typeof predicate.frText === "function")
                        value = predicate.frText();
                    else if (typeof predicate.frText === "string")
                        value = predicate.frText;
                }
                else if (currentLanguage === 'en' && predicate.enText) {
                    if (typeof predicate.enText === "function")
                        value = predicate.enText();
                    else if (typeof predicate.enText === "string")
                        value = predicate.enText;
                }
            }

            // Update popover content
            var popover = $(element).data('bs.popover');
            popover.options.content = value;
        },
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = ko.unwrap(allBindingsAccessor());

            // options defaults
            var options = ko.bindingHandlers.popover.options;

            // Get binding values
            if (allBindings.popoverOptions && typeof allBindings.popoverOptions == "object")
                options = $.extend({}, ko.bindingHandlers.popover.options, allBindings.popoverOptions);

            // Setup basic popover settings
            $(element).popover(options);
        },
        options: {
            placement: "top",
            trigger: "hover"
        }
    };
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	sort knockout binder
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.responsive = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var timeoutCallback = null;
            var updateClasses = function () {
                var classToAdd = '';
                var width = $(element).width();
                if (width >= 1200)
                    classToAdd = 'ino-lg';
                else if (width >= 992)
                    classToAdd = 'ino-md';
                else if (width >= 769)
                    classToAdd = 'ino-sm';
                else if (width >= 551)
                    classToAdd = 'ino-xs';
                else if (width <= 550)
                    classToAdd = 'ino-xxs';

                $(element).removeClass('ino-lg ino-md ino-sm ino-xs ino-xxs');
                $(element).addClass(classToAdd);
            };


            $(window).on('resize', function () {
                if (timeoutCallback != null)
                    clearTimeout(timeoutCallback);

                timeoutCallback = setTimeout(function () {
                    updateClasses();
                }, 150);
            });
            updateClasses();
        }
    };
})(inovestor.ms.libRef.ko, inovestor);

/* 
	simpleUrl knockout binder
	Options:	-defaultValue (string / observable / function) : Url to transform
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.simpleUrl = {
        update: function (element, valueAccessor) {
            var valueBinding = ko.unwrap(valueAccessor());

            // value getter
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType == "function")
                value = predicate();
            else if (predicateType == "string")
                value = predicate;

            var finalUrl = null;
            if (typeof value === "string") {
                var originalUrl = ko.utils.unwrapObservable(valueAccessor());
                
                //find & remove protocol (http, ftp, etc.) and get domain
                if (value.indexOf("://") > -1)
                    finalUrl = value.split('/')[2];
                else
                    finalUrl = value.split('/')[0];

                //find & remove port number
                finalUrl = finalUrl.split(':')[0];
            }

            ko.bindingHandlers.text.update(element, function(){ return finalUrl; });
        }
    }
})(inovestor.ms.libRef.ko, inovestor);

/* 
    Knockout binding handler to be applied on an element.
    For every element found within that has a sortableFor

    On <TABLE>:
        sortable: { 
            selector: 'th',
            data: [observableArray], 
            sortedHeader: [observable], 
            isAsc: [observable] 
        }
    On <TH>:
        sortableFor : [string (property name accessor) || function (callback returning value to sort)]
        defaultSort : [bool (sets direction for default sorting)],
*/
; (function (ko, inovestor, undefined) {
    ko.bindingHandlers.sortable = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var tableHeaders = [];
            var sortedHeader = null;
            var value = ko.unwrap(valueAccessor());
            var dataToSort = value.data;
            var isAsc = null;
          

            // Get selector or use 'th' as default
            var selector = value.selector || 'th';
            var defaultSortableForEle = null;

            $(element).find(selector).each(function () {
                var bindings = ko.bindingProvider.instance.getBindings(this, bindingContext);
                if (!inovestor.ms.core.isNullOrUndefined(bindings) && !inovestor.ms.core.isNullOrUndefined(bindings.sortableFor)) {
                    var sortableFor = ko.unwrap(bindings.sortableFor);
                    tableHeaders.push({ element: this, sortableFor: sortableFor })

                    var defaultSort = ko.unwrap(bindings.defaultSort);
                    if (!inovestor.ms.core.isNullOrUndefined(defaultSort) && typeof defaultSort == 'boolean'){
                        defaultSortableForEle = this;
                        isAsc = defaultSort;
                    }
                }
            });

            $(tableHeaders).each(function (index, tableHeader) {
                tableHeader.element.style.cursor = 'pointer';

                tableHeader.element.onclick = function () {
                    if (sortedHeader != null)
                        $(sortedHeader.element).find('.sortable-icon').remove();

                    if(inovestor.ms.core.isNullOrUndefined(isAsc))
                        isAsc = true;
                    if (sortedHeader == tableHeader)
                        isAsc = !isAsc;

                    sortedHeader = tableHeader;
                    ko.bindingHandlers.sortable.sort(tableHeader.sortableFor, dataToSort, isAsc);

                    if (isAsc)
                        $(sortedHeader.element).append(ko.bindingHandlers.sortable.getArrowUpHTML());
                    else
                        $(sortedHeader.element).append(ko.bindingHandlers.sortable.getArrowDownHTML());

                    // Set the current sorting info to passed observables (if any)
                    if (!inovestor.ms.core.isNullOrUndefined(value.sortedHeader))
                        value.sortedHeader(sortedHeader);
                    if (!inovestor.ms.core.isNullOrUndefined(value.isAsc))
                        value.isAsc(isAsc);
                }
            });

            setTimeout(function () {
                if (defaultSortableForEle)
                    $(defaultSortableForEle).trigger('click');
            });
        },
        sort: function (prop, data, isAsc) {
            if(!data || !data.sort)
                return;

            if(typeof data == 'function' && inovestor.ms.core.isNullOrUndefined(data()))
                return;
            
            data.sort(function (left, right) {
                var a = left;
                var b = right;

                if (a && b) {

                    var aResult = typeof prop == 'function' ? prop.apply(a) : a[prop];
                    var bResult = typeof prop == 'function' ? prop.apply(b) : b[prop];
                    var isANullOrUndefined = typeof aResult == 'number' ? isNaN(aResult) : inovestor.ms.core.isNullOrUndefined(aResult);
                    var isBNullOrUndefined = typeof bResult == 'number' ? isNaN(bResult) :inovestor.ms.core.isNullOrUndefined(bResult)

                    if (isANullOrUndefined || isBNullOrUndefined) {
                        if (isANullOrUndefined && !isBNullOrUndefined)
                            return 1;
                        else if (!isANullOrUndefined && isBNullOrUndefined)
                            return -1;
                        else
                            return 0;
                    }
                    else {
                        // Swtich sides if descending
                        if (!isAsc) {
                            var aR = aResult;
                            aResult = bResult;
                            bResult = aR;
                        }

                        if (aResult instanceof Date && bResult instanceof Date) {
                            return aResult - bResult;
                        }

                        var aStrResult = aResult + '';
                        var bStrResult = bResult + '';
                        var aNum = parseFloat(aStrResult.replace(/,/g, ''));
                        var bNum = parseFloat(bStrResult.replace(/,/g, ''));

                        if (aNum && bNum) {
                            // Number comparison
                            if (aNum > bNum) {
                                return 1;
                            } else if (aNum < bNum) {
                                return -1;
                            }

                            return 0;
                        } else {
                            // String comparison
                            if (aStrResult > bStrResult) {
                                return 1;
                            } else if (aStrResult < bStrResult) {
                                return -1;
                            }

                            return 0;
                        }
                    }
                }

                return 0;
            });
        },
        getArrowUpHTML: function () {
            return '<span class="sortable-icon" style="margin-left:4px;display: inline-block;width:0; height:0; border-right:5px solid transparent;border-left:5px solid transparent;border-bottom:5px solid #222"></span>'
        },
        getArrowDownHTML: function () {
            return '<span class="sortable-icon" style="margin-left:4px;display: inline-block;width:0; height:0; border-right:5px solid transparent;border-left:5px solid transparent;border-top:5px solid #222"></span>'
        }
    };
})(inovestor.ms.libRef.ko, inovestor);

/* 
	Percentage knockout binder
	Options:	-formatValues (object)
                -defaultValue (string)
                -asHtml (bool)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.stringFormat = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // Options defaults
            var formatValues = {};
            var defaultValue = resources.stringFormatFormats.empty;
            var asHtml = false;

            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.formatValues)) {
                if (typeof allBindings.formatValues === "function")
                    formatValues = allBindings.formatValues();
                else if (typeof allBindings.formatValues === "object")
                    formatValues = allBindings.formatValues;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue)) {
                if (typeof allBindings.defaultValue === "string")
                    defaultValue = defaultValue;
            }
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.asHtml)) {
                if (typeof allBindings.asHtml === "boolean")
                    asHtml = allBindings.asHtml;
            }

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof valueBinding;
            if (predicateType === "function")
                value = predicate();
            else if (predicateType === "string")
                value = predicate;

            var formattedValue = defaultValue;
            if (!inovestor.ms.core.isEmptyString(value)) {
                result = inovestor.ms.core.stringFormat(value, formatValues);
                if (!inovestor.ms.core.isEmptyString(result))
                    formattedValue = result;
            }

            if (!asHtml) {
                ko.bindingHandlers.text.update(
                    element,
                    function () { return formattedValue; }
                    );
            }
            else
                ko.bindingHandlers.html.update(
                    element,
                    function () { return formattedValue; }
                    );
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
	Text Binder (to enable default values when empty/null)
	Options:	-defaultValue (string)
*/
; (function (ko, numeral, inovestor, undefined) {
    ko.bindingHandlers.textValue = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var valueBinding = ko.unwrap(valueAccessor());
            var allBindings = ko.unwrap(allBindingsAccessor());
            var resources = inovestor.ms.core.getCurrentResource(inovestor.ms.ko.resources);

            // Options defaults
            var defaultValue = resources.textValueFormats.empty;

            // Get binding values
            if (!inovestor.ms.core.isNullOrUndefined(allBindings.defaultValue)) {
                if (typeof allBindings.defaultValue === "string")
                    defaultValue = defaultValue;
            }

            // Get value depending on supported types
            var value = null;
            var predicate = valueBinding;
            var predicateType = typeof predicate;
            if (predicateType === "function")
                value = predicate();
            else if (predicateType === "string")
                value = predicate;

            var formattedValue = defaultValue;
            if (!inovestor.ms.core.isEmptyString(value)) {
                formattedValue = value;
            }

            ko.bindingHandlers.text.update(
				element,
				function () { return formattedValue; }
				);
        }
    }
})(inovestor.ms.libRef.ko, inovestor.ms.libRef.numeral, inovestor);

/* 
    Binding handler to be used with InoMsFramework.
    If you don't know what InoMsFramework is, you shouldn't be using this.
*/
; (function (ko, undefined) {
    ko.bindingHandlers.view = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
            var allBindings = ko.unwrap(allBindingsAccessor());
            var $element = $(element);
            var viewObservable = valueAccessor();

            var sub = viewObservable.subscribe(function (view) {
                // Remove template
                if ($element.children().length > 0) {
                    // Make sure knockout's dom Node Disposal is run on removed elements
                    ko.utils.domNodeDisposal.removeNode($element.children()[0]);
                    $element.find("> *").remove();
                }

                if (view != null) {
                    // Get and update template 
                    view.component.render().then(function () {
                        view.component.getTemplateAsync().then(function (template) {
                            var tagName = view.component.getHtmlTagName();
                            $element.html("<" + tagName + ">" + template + "</" + tagName + ">");
                            // Update viewmodel binding using With bindinghandler
                            ko.bindingHandlers.with.init(
                                $element.find("> " + tagName)[0],
                                function () { return view.component.viewModel },
                                null,
                                viewModel,
                                context
                            );
                        });
                    });
                }
            });
            viewObservable.valueHasMutated();

            // Add a knockout domNodeDisposal callback to dispose the subscription to disableManualOrdering
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                sub.dispose();
            });
        }
    }
})(inovestor.ms.libRef.ko);


/* 
	Bootstrap checkbox list dropdown (with accessibility and keyboard navigation support improvements)

    T: Type of an option item
    V: Type of an option item value

	Options:	-options: (T[] | KnockoutObservableArray<T> | KnockoutObservable<T[]> | KnockoutComputed<T[]>) [Required]
                -getText: (item: T) => string [Required]
                -getValue: (item: T) => V [Required]
                -selection: KnockoutObservableArray<V> [Required]
                
                -triggerTag: ('a' | 'button') [Optional | Default: 'button']
                -triggerAttributes: object [Optional]

                -right: boolean [Optional | Default: false]

                -displaySelectAll: boolean [Optional | Default : false]

    Slot:       Default slot content will be used as the dropdown trigger content
*/
; (function () {
    ko.components.register('ino-ms-checkbox-list-dropdown', {
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new function () {
                    this.params = params
    
                    var focusOutCloseTimeoutHandle = null


                    this.selectAllText = inovestor.ms.ko.currentLanguage() === 'en' ? 'Select All' : 'Sélectionner tout'

                    // Computed observable to determine the state of "Select All"
                    this.isAllSelected = ko.pureComputed(function () {
                        var options = ko.unwrap(params.options); // Unwrap the observable or array
                        var selection = ko.unwrap(params.selection); // Unwrap the observable array

                        return selection.length === options.length
                    })
                    
                    // Function to toggle "Select All"
                    this.toggleSelectAll = function () {
                        var options = ko.unwrap(params.options); // Unwrap the observable or array
                        var selection = ko.unwrap(params.selection); // Unwrap the observable array

                        if (selection.length === options.length) {
                             params.selection([]);
                        } else {
                            var allValues = options.map(this.params.getValue);
                            this.params.selection(allValues);
                        }
                        
                        return true
                    }


                    // Computed observable to determine if the "Select All" checkbox should be indeterminate
                    this.selectAllIsIndeterminate = ko.pureComputed(function () {
                        var options = ko.unwrap(params.options); // Unwrap the observable or array
                        var selection = ko.unwrap(params.selection); // Unwrap the observable array

                        return selection.length > 0 && selection.length < options.length;
                    })


                    $(componentInfo.element).on('focusout', function () {
                        if (focusOutCloseTimeoutHandle) clearTimeout(focusOutCloseTimeoutHandle)
                        focusOutCloseTimeoutHandle = setTimeout(function () {
                            if ($(componentInfo.element).find('.dropdown-menu').is(':visible')) {
                                $(componentInfo.element).find('.dropdown-toggle').dropdown('toggle')
                            }
                        }, 100)
                    })
    
                    $(componentInfo.element).on('focusin', function () {
                        if (focusOutCloseTimeoutHandle) clearTimeout(focusOutCloseTimeoutHandle)
                    })
    
                    $(componentInfo.element).on('click', '.dropdown-menu li', function (e) {
                        e.stopPropagation()
                        $(this).find('input').click()
                    })
    
                    $(componentInfo.element).on('click', 'input[type="checkbox"], .dropdown-menu label', function (e) {
                        e.stopPropagation()
                    })
                }
            }
        },
    
        template: '<div class="dropdown ino-ms-checkbox-dropdown-list">' +
            '<!-- ko if: params.triggerTag == null || params.triggerTag === "button" -->' +
            '<button class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bind="attr: params.triggerAttributes">' +
                '<!-- ko template: { nodes: $componentTemplateNodes, data: $parent } --><!-- /ko -->' +
            '</button>' +
            '<!-- /ko -->' +
            '<!-- ko if: params.triggerTag === "a" -->' +
            '<a href="#" role="button" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bind="attr: params.triggerAttributes">' +
                '<!-- ko template: { nodes: $componentTemplateNodes, data: $parent } --><!-- /ko -->' +
            '</a>' +
            '<!-- /ko -->' +
            '<ul class="dropdown-menu" role="menu" data-bind="css: { \'dropdown-menu-right\': params.right }">' +
               '<!-- ko if: params.displaySelectAll -->' +
                    '<li role="none">' +
            '<a href="#" tabindex="-1" role="menuitemcheckbox" data-bind="attr: { \'aria-checked\': $component.isAllSelected() ? \'true\' :  ($component.selectAllIsIndeterminate() ? \'mixed\' : \'false\')}" >' +
                            '<label>' +
                                '<input type="checkbox" data-bind="checked: $component.isAllSelected(), indeterminate: $component.selectAllIsIndeterminate() ,click: $component.toggleSelectAll"  tabindex="-1" aria-hidden="true" inert>' +
                                ' ' + 
                                    '<span data-bind="text: $component.selectAllText"></span>' +
                            '</label>' +
                        '</a>'+
                    '</li>' +
                '<!-- /ko-->' + 
                '<!-- ko foreach: params.options -->' +
                    '<li role="none">' +
                        '<a href="#" tabindex="-1" role="menuitemcheckbox" data-bind="attr: { \'aria-checked\': $component.params.selection().includes($component.params.getValue($data)) }">' +
                            '<label>' +
                                '<input type="checkbox" data-bind="checkedValue: $component.params.getValue($data), checked: $component.params.selection" tabindex="-1" aria-hidden="true" inert>' +
                                ' ' + 
                                '<span data-bind="html: $component.params.getText($data)"></span>' +
                            '</label>' +
                        '</a>' +
                    '</li>' +
                '<!-- /ko -->' +
                
            '</ul>' +
        '</div>'
    });
})()

; (function (inovestor, undefined) {
    inovestor.ms.ko.templates = inovestor.ms.ko.templates || {};
    inovestor.ms.ko.templates.changeIndicator =
    '<div class="change-container" data-bind="if : change() !== null || percentChange() !== null, css : { \'positive-change\' : percentChange() > 0, \'negative-change\' : percentChange() < 0 }">' +
    '   <span class="pull-left" data-bind="style: { width: leftWidth }, currency: change, showZero: true, maxDecimalPlaces: 4, defaultValue: \'\'"></span>' +
    '   <span class="indicator"></span>' +
    '   <span class="pull-right" data-bind="style: { width: rightWidth }, percentage: percentChange, showZero: true, decimalPlaces:2, valueAsPercent:true, defaultValue: \'\'"></span>' +
    '</div>';
})(inovestor);



; (function (inovestor, undefined) {
    inovestor.ms.ko.templates = inovestor.ms.ko.templates || {};
    inovestor.ms.ko.templates.checkbox =
    '<div class="ino-checkbox-group" data-toggle="buttons">' +
    '   <label class="btn" data-bind="click: onCheckedToggle, css: { active : isChecked }">' +
    '       <span class="fa-stack">' +
    '           <i class="fa fa-square-o fa-stack-2x"></i>' +
    '           <i class="fa fa-check fa-stack-1x"></i>' +
    '       </span>' +
    '       <span class="ino-checkbox-label" data-bind="text: labelText"></span>' +
    '    </label>' +
    '</div>';
  
})(inovestor);

; (function (inovestor, undefined) {
    inovestor.ms.ko.templates = inovestor.ms.ko.templates || {};
    inovestor.ms.ko.templates.drowdown = 
    '<div class="dropdown field-selector">' +
    '   <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' +
    '       <span class="selected-value" data-bind="text: selectedName() + \'&nbsp;\'"></span>' +
    '       <span class="caret"></span>' +
    '   </button>' +
    '   <!-- ko if : isFilterable()  -->' +
    '       <input type="text" class="filterable-input" data-bind="value : inputFilter, valueUpdate: \'afterkeydown\', event: { click: toggleDropdowMenu }" />' +
    '   <!-- /ko -->' +
    '   <div class="dropdown-menu dropdown-menu-container field-types">' +
    '       <!-- ko if : subMenuGroupKey !== null -->' +
    '           <ul class="dropdown-menu" data-bind="groupBy: subMenuGroupKey, dataArray: items()">' +
    '               <li class="dropdown-submenu">' +
    '                   <a data-bind="attr: { \'backText\' : \'back\' }, event: {click: $parent.onItemSelected } ">' +
    '                       <span data-bind="text: $parent.itemName($data) + \'&nbsp;\'"></span>' +
    '                   </a>' +
    '                   <ul class="dropdown-menu" data-bind="foreach: groupItems">' +
    '                       <li data-bind="css: { \'active\' : $parentContext.$parent.selectedValue() === $data }">' +
    '                           <a class="action" data-bind="event: { click: $parentContext.$parent.onSubMenuItemSelected }">' +
    '                               <span data-bind="text: $parentContext.$parent.subMenuItemName($data)"></span>' +
    '                           </a>' +
    '                       </li>' +
    '                   </ul>' +
    '               </li>' +
    '           </ul>' +
    '       <!-- /ko -->' +
    '       <!-- ko if : subMenuGroupKey === null -->' +
    '           <ul class="dropdown-menu">' +
    '               <!-- ko foreach : items() -->' +
    '               <li data-bind="css: { \'active\' : $parent.selectedValue() === $data }">' +
    '                   <a class="action" data-bind="attr: { \'backText\' : \'back\' }, event: {click: $parent.onItemSelected }">' +
    '                       <span data-bind="text: $parent.itemName($data) + \'&nbsp;\'"></span>' +
    '                   </a>' +
    '               </li>' +
    '               <!-- /ko -->' +
    '           </ul>' +
    '       <!-- /ko -->' +
    '   </div>' +
    '</div>';
  
})(inovestor);

; (function (inovestor, undefined) {
    inovestor.ms.ko.templates = inovestor.ms.ko.templates || {};
    inovestor.ms.ko.templates.holdButton =
    '<div class="confirm-wrapper" data-bind="event: { touchstart : onClick, touchend : onUnClick, mousedown : onClick, mouseup : onUnClick, mouseleave: onUnClick }">' +
    '    <div class="confirm-btn">' +
    '        <span class="fa-stack">' +
    '            <i class="fa fa-circle-thin fa-stack-2x"></i>' +
    '            <i class="fa fa-close fa-stack-1x"></i>' +
    '        </span>' +
    '    </div>' +
    '    <div class="confirm-bg">' +
    '        <span class="fa-stack">' +
    '            <i class="fa fa-circle-thin fa-stack-2x"></i>' +
    '        </span>' +
    '    </div>' +
    '    <div class="mask_left"></div>' +
    '    <div class="mask_right"></div>' +
    '</div>';
})(inovestor);



; (function (inovestor, undefined) {
    inovestor.ms.ko.resources = inovestor.ms.ko.resources || {};
    inovestor.ms.ko.resources["en"] = {
        currencyFormats: { 
            empty : '-',
            noDecimals: '$0,0',
            withDecimals: '$0,0.{decimals}',
            largeNumberWithDecimals: '$0.{decimals}a',
            largeNumberNoDecimals: '$0a'
        },
        numericFormats: {
            empty: '-',
            noDecimals: '0,0',
            withDecimals: '0,0.{decimals}',
            largeNumberWithDecimals: '0.{decimals}a',
            largeNumberNoDecimals: '0a'
        },
        percentFormats: {
            empty: '-',
            noDecimals: '0,0%',
            withDecimals: '0,0.{decimals}%'
        },
        textValueFormats: {
            empty: '-'
        },
        localizedTextFormats: {
            empty: '-'
        },
        stringFormatFormats: {
            empty: '-'
        },
        dateFormats: {
            empty: '-'
        },
        ordinalFormats: {
            empty: '-'
        }
    };
})(inovestor);

; (function (inovestor, undefined) {
    inovestor.ms.ko.resources = inovestor.ms.ko.resources || {};
    inovestor.ms.ko.resources["fr"] = {
        currencyFormats: {
            empty: '-',
            noDecimals: '0,0 $',
            withDecimals: '0,0.{decimals} $',
            largeNumberWithDecimals: '0,0.{decimals} a$',
            largeNumberNoDecimals: '0,0 a$'
        },
        numericFormats: {
            empty: '-',
            noDecimals: '0,0',
            withDecimals: '0,0.{decimals}',
            largeNumberWithDecimals: '0.{decimals} a',
            largeNumberNoDecimals: '0 a'
        },
        percentFormats: {
            empty: '-',
            noDecimals: '0,0 %',
            withDecimals: '0,0.{decimals} %'
        },
        textValueFormats: {
            empty: '-'
        },
        localizedTextFormats: {
            empty: '-'
        },
        stringFormatFormats: {
            empty: '-'
        },
        dateFormats: {
            empty: '-'
        },
        ordinalFormats: {
            empty: '-'
        }
    };
})(inovestor);
